const LAY_DANH_SACH_TINH_THANH_THANH_CONG = (state, danhSachTinhThanh) => {
  state.danhSachTinhThanh = danhSachTinhThanh;
};

const LAY_DANH_SACH_TINH_THANH_TRONG_VUNG_THANH_CONG = (state, payload) => {
  state.danhSachTinhThanhTrongVung = payload;
};

const LAY_DANH_SACH_TINH_THANH_FREE_THANH_CONG = (state, payload) => {
  state.danhSachTinhThanhFree = payload;
};



export default {
  LAY_DANH_SACH_TINH_THANH_THANH_CONG,
  LAY_DANH_SACH_TINH_THANH_TRONG_VUNG_THANH_CONG,
  LAY_DANH_SACH_TINH_THANH_FREE_THANH_CONG
};
